import type { BaseTaskService } from './base-task-service';

export const TaskRecentService = Symbol.for('TaskRecentService');

export interface TaskRecentService extends BaseTaskService<void> {}
